import { ajax } from './ajax.js';
import { originalModal } from './modal.js';
export const cart = () => {
  // 「削除する」ボタンがクリックされたときの処理
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-action="cart-delete"]');
    if (!button) return;

    event.preventDefault(); // フォーム送信を止める

    const requestCode = button.dataset.requestCode;
    const currentUri = button.dataset.currentUri;
    const key = button.dataset.key;
    const goodsId = button.dataset.goodsId;

    handleCartUpdate({
      requestCode,
      currentUri,
      type: 'goods_remove',
      key,
      goodsId,
      button,
    });
  });

  // 数量セレクトボックスが変更されたときの処理
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!select.matches('.tagStyle-select[name="count"]')) return;

    const newCount = select.value;
    const key = select.dataset.key;
    const goodsId = select.dataset.goodsId;
    const requestCode = select.dataset.requestCode;
    const currentUri = select.dataset.currentUri;

    handleCartUpdate({
      requestCode,
      currentUri,
      type: 'goods_update',
      key,
      goodsId,
      count: newCount,
      button: select,
    });
  });

  // 数量セレクトボックスがフォーカスされたときに現在の値を保持しておく
  document.addEventListener('focusin', (event) => {
    const select = event.target;
    if (select.matches('.tagStyle-select[name="count"]')) {
      select.dataset.prevValue = select.value;
    }
  });

  /**
   * カート内商品の更新・削除処理（共通関数）
   */
  async function handleCartUpdate({ requestCode, currentUri, type, key, goodsId, count, button }) {
    // GET パラメータの組み立て
    const actionKey = `${type}[${key}]`;
    const params = new URLSearchParams({
      'wwwrequestcode': requestCode,
      'current_uri': currentUri,
      [actionKey]: '',
      id: goodsId,
    });

    // 数量変更の場合は count もパラメータに追加
    if (count !== undefined) {
      params.set('count', count);
    }

    const url = `/action/cart.php?${params.toString()}`;
    const submitBuy = document.querySelector('#submitBuy');

    try {
      // サーバーへリクエスト送信
      const result = await ajax.get(url);

      // サーバーからの戻り値をセット
      document.querySelectorAll('[data-request-code]').forEach((el) => {
        el.dataset.requestCode = result.requestCode;
      });

      if (result.status === 'success') {
        // --- 共通: UI 表示を更新 ---
        updatePriceSpan(key, result.sumPrice, result.totalPrice, result.amount); // 合計・小計の更新
        toggleFreeShippingBox(result.priceDiff); // 送料無料金額の表示更新
        updateDeliveryCharge(result.priceDiff); // 送料の表示更新(confirmページ)

        // ヘッダーのカート内商品数表示を更新
        const cartCountSpan = document.querySelector('.in-cart');
        if (cartCountSpan) {
          cartCountSpan.textContent = result.count;
        }

        // エラー表示を初期化
        const errorContainer = document.querySelector('.error');
        if (errorContainer) {
          errorContainer.innerHTML = '';
        }

        // ボタン表示の更新
        if (submitBuy) {
          submitBuy.classList.remove('inactive', 'primary');
          submitBuy.classList.add(result.canBuy ? 'primary' : 'inactive');
        }

        // セレクト要素を新しい値で保存
        if (button && button.matches('.tagStyle-select[name="count"]')) {
          button.dataset.prevValue = button.value;
        }

        // --- 削除時のみ行う処理 ---
        if (type === 'goods_remove') {
          button.closest('.item')?.remove();

          // カートが空になったかチェック
          const cartItemList = document.querySelector('.in-cart-item-list');
          const remainingItems = cartItemList?.querySelectorAll('.item');

          if (cartItemList && (!remainingItems || remainingItems.length === 0)) {
            // カートリストを削除してメッセージを表示
            cartItemList.remove();
            const emptyMessage = document.createElement('p');
            emptyMessage.textContent = 'カート内に商品がありません。';

            // .in-cart-item-wrap の中に挿入
            const cartItemWrap = document.querySelector('.in-cart-item-wrap');
            if (cartItemWrap) {
              cartItemWrap.appendChild(emptyMessage);
            }

            // 「購入手続きへ進む」ボタンを非活性化
            const inCartLayout = document.querySelector('.in-cart-layout');
            const checkoutButton = inCartLayout?.querySelector('.btn.primary');
            if (checkoutButton) {
              checkoutButton.classList.add('inactive');
              checkoutButton.classList.remove('primary');
            }
          }

          setTimeout(() => {}, 500);
          const { closeModal } = originalModal();
          const modal = button.closest('.modal');
          closeModal(modal);
        }
      } else {
        // バリデーションエラーまたはその他エラー時
        if (result.status === 'validation-error') {
          renderErrorMessages(result.errors, '.error');
        } else {
          alert(`${type === 'goods_remove' ? '削除' : '数量変更'}に失敗しました。`);
        }

        if (submitBuy) {
          submitBuy.classList.remove('primary');
          submitBuy.classList.add('inactive');
        }

        // セレクトの値を元に戻す（複数対応）
        const selectElements = document.querySelectorAll('.tagStyle-select[name="count"]');
        selectElements.forEach((select) => {
          if (select.dataset.prevValue !== undefined) {
            select.value = select.dataset.prevValue;
          }
        });
      }
    } catch (err) {
      alert('通信エラーが発生しました。');

      if (submitBuy) {
        submitBuy.classList.remove('primary');
        submitBuy.classList.add('inactive');
      }

      // セレクトの値を元に戻す（通信エラー時も）
      const selectElements = document.querySelectorAll('.tagStyle-select[name="count"]');
      selectElements.forEach((select) => {
        if (select.dataset.prevValue !== undefined) {
          select.value = select.dataset.prevValue;
        }
      });
    }
  }

  function toggleFreeShippingBox(priceDiff) {
    const freeShippingBox = document.querySelector('.free-shipping-at');
    const diffSpans = document.querySelectorAll('.price-diff');

    if (diffSpans.length === 0) return;

    // すべての .price-diff 要素の中身を更新
    diffSpans.forEach((span) => {
      span.textContent = priceDiff;
    });

    if (!freeShippingBox) return;

    if (priceDiff == 0 || priceDiff === '0') {
      freeShippingBox.style.display = 'none';
    } else {
      freeShippingBox.style.display = '';
    }
  }

  /**
   * confirmページでの送料表示更新
   * @param priceDiff
   */
  function updateDeliveryCharge(priceDiff) {
    // item-delivery-charge の値を更新
    const deliveryChargeElement = document.querySelector('.item-delivery-charge');
    if (deliveryChargeElement) {
      const defaultDeliveryCharge = deliveryChargeElement.dataset.deliveryCharge;
      if (priceDiff === 0 || priceDiff === '0') {
        deliveryChargeElement.textContent = '0';
      } else {
        deliveryChargeElement.textContent = defaultDeliveryCharge;
      }
    }
  }

  function updatePriceSpan(key, sumPrice, totalPrice, orderAmount) {
    const sumPriceSpan = document.querySelector(`.item-subtotal[data-key="${key}"]`);
    const totalPriceSpan = document.querySelector('#cart-item-total-price');
    const orderAmountSpan = document.querySelector('#order-amount');

    if (sumPriceSpan) {
      sumPriceSpan.textContent = sumPrice;
    }

    if (totalPriceSpan) {
      totalPriceSpan.textContent = totalPrice;
    }

    if (orderAmountSpan) {
      orderAmountSpan.textContent = orderAmount;
    }
  }

  function renderErrorMessages(messages, containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.warn(`Container "${containerSelector}" が見つかりません。`);
      return;
    }

    container.innerHTML = ''; // 一旦初期化（必要に応じて）

    messages.forEach((message) => {
      const p = document.createElement('p');
      p.textContent = message;
      container.appendChild(p);
    });
  }
}
